import { useEffect } from "react";
import Popup from "../../../../../../common/components/popup";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { accounts } from "../../../../../../redux/accounts/action";
import { dbas } from "../../../../../../redux/dbas/action";
import { GatewayOpenNetworkSubscription } from "./gateway-open-network-subscription";
import { useSelector } from "react-redux";
import { selectDbasQueryItems } from "../../../../../../redux/dbas/selector";
import { selectAccountsQueryItems } from "../../../../../../redux/accounts/selector";
import { selectTenantOpennetworkDomainsListItems } from "../../../../../../redux/tenant-open-network-domains/selector";

export const GatewayOpenNetworkSubscriptionPopup = ({
  selectedGateway,
  closeModal,
}: any) => {
  const dispatch = useAppDispatch();
  const dbaData = useSelector(selectDbasQueryItems)
  const accountData = useSelector(selectAccountsQueryItems)
  const domainItems = useSelector(selectTenantOpennetworkDomainsListItems)

  const fetchdbasById = async (dbaId: any) => {
    await dispatch(dbas.resetAction({ actionType: 'query' }))
    await dispatch(dbas.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/dbas/fetch-detail`,
      entity: 'dbas',
      jsonData: {
        Context: {},
        Records: [
          {
            DBAId: selectedGateway?.DBAId
          }
        ]
      }
    }))
  }

  const getAccoutDetails = async (accountId: any) => {
    await dispatch(accounts.resetAction({ actionType: 'query' }))
    await dispatch(accounts.query({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/query`,
      entity: 'accounts',
      jsonData: {
        Records: [
          {
            Context: {},
            Message: {
              Id: accountId
            }

          }
        ]
      }
    }))
  }

  const handleFormSubmit = () => {
    closeModal();
  }

  useEffect(() => {
    console.log('dbaData', dbaData)
    const accountId = dbaData?.result?.items?.AccountId
    if (accountId) {
      getAccoutDetails(accountId)
    }
  }, [dbaData]);

  useEffect(() => {
    console.log('DBAId', selectedGateway?.DBAId)
    if (selectedGateway?.DBAId) {
      fetchdbasById(selectedGateway?.DBAId)
    }
  }, [selectedGateway]);

  useEffect(() => {
    console.log('accountData', accountData)
  }, [accountData]);


  return (
    <>
      <Popup onClose={closeModal}>
        <>
          <GatewayOpenNetworkSubscription
            selectedGateway={selectedGateway}
            accountData={accountData?.result?.items}
            domainItems={domainItems}
            closeModal={closeModal}
          />
          <div className='flex w-full justify-end items-end'>
            <button
              onClick={closeModal}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            >
              Back
            </button>
            <button
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}

              type="submit"
            >
              Subscribe
            </button>
          </div>
        </>
      </Popup >
    </>
  )
}